import { render, staticRenderFns } from "./forgotPassword.vue?vue&type=template&id=7d75286c&scoped=true"
import script from "./forgotPassword.vue?vue&type=script&lang=js"
export * from "./forgotPassword.vue?vue&type=script&lang=js"
import style0 from "./forgotPassword.vue?vue&type=style&index=0&id=7d75286c&prod&lang=scss&scoped=true"
import style1 from "./forgotPassword.vue?vue&type=style&index=1&id=7d75286c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d75286c",
  null
  
)

export default component.exports